export function assignSectionAssets(paragraphs = [], assets = []) {
    const assetsById = new Map(
        assets.filter((asset) => asset?.assetId).map((asset) => [asset.assetId, asset])
    );
    const assignedIds = new Set();
    const paragraphAssets = paragraphs.map((paragraph) => (
        (paragraph?.assetRefs || []).flatMap((assetId) => {
            if (assignedIds.has(assetId) || !assetsById.has(assetId)) return [];
            assignedIds.add(assetId);
            return [assetsById.get(assetId)];
        })
    ));

    return {
        paragraphAssets,
        unreferencedAssets: assets.filter(
            (asset) => asset?.assetId && !assignedIds.has(asset.assetId)
        ),
    };
}
